module.exports = __webpack_public_path__ + "img/CCAPPLOGO.f0164e29.png";